
export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.7,
      ease: "easeOut"
    }
  })
};

export const logoAnimation = {
  initial: { scale: 0.9, opacity: 0 },
  animate: { 
    scale: 1, 
    opacity: 1,
    transition: { 
      type: "spring",
      stiffness: 100,
      damping: 15,
      delay: 0.2
    }
  }
};

export const bounceAnimation = {
  y: ["0%", "20%", "0%"],
  transition: {
    duration: 1.2,
    repeat: Infinity,
    ease: "easeInOut"
  }
};

export const sparkleAnimation = {
  scale: [1, 1.2, 1],
  rotate: [0, 15, 0],
  opacity: [0.7, 1, 0.7],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut"
  }
};
